/* eslint-disable */
import _ from 'lodash';

const DropdownIndicator = (props) => {
  return (
    components.DropdownIndicator && (
      <components.DropdownIndicator {...props}>
        <FontAwesomeIcon
          icon={props.selectProps.menuIsOpen ? 'caret-up' : 'caret-down'}
        />
      </components.DropdownIndicator>
    )
  );
};

export const reactSelectCustomStyle = {
  control: (base, { isDisabled }) => ({
    ...base,
    backgroundColor: 'none',
    minHeight: 30,
    width: 'auto',
    border: 'none',
    boxShadow: 'none',
    fontSize: 10,
  }),
  placeholder: (base, { isDisabled }) => ({
    color: isDisabled ? '#dedede' : 'inherit',
  }),
  indicatorSeparator: () => {},
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: 4,
    color: 'blue',
    transition: 'all .2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  singleValue: (base) => ({
    ...base,
    color: 'blue',
  }),
  input: (base) => ({
    ...base,
    color: 'blue',
  }),
};
export const reactSelectFilterStyle = {
  control: (base) => ({
    ...base,
    backgroundColor: 'none',
    minHeight: 30,
    width: 120,
    border: '1px solid black',
    boxShadow: 'none',
    fontSize: 10,
  }),
  indicatorSeparator: () => {},
};

export const reactSelectCustomStyleBigger = {
  menu: (base, state) => ({
    ...base,
    zIndex: 1,
  }),
  control: (base, { isDisabled }) => ({
    ...base,
    backgroundColor: 'none',
    minHeight: 30,
    width: 147,
    border: 'none',
    boxShadow: 'none',
    fontSize: 15,
  }),
  placeholder: (base, { isDisabled }) => ({
    color: isDisabled ? '#dedede' : 'inherit',
  }),
  indicatorSeparator: () => {},
  dropdownIndicator: (base, state) => ({
    ...base,
    padding: 4,
    color: 'blue',
    transition: 'all .2s ease',
    transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
  }),
  clearIndicator: (base) => ({
    ...base,
    padding: 4,
  }),
  singleValue: (base) => ({
    ...base,
    color: 'blue',
  }),
  input: (base) => ({
    ...base,
    color: 'blue',
  }),
};
